<script>
// import ListPage from "@/components/list.vue";
import Header from "@/components/Header.vue";
import ListControls from "@/components/listControls.vue";
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import _ from "lodash";
import axios from "axios";
import AddUser from "@/components/modal/AddUser.vue";
import EditUser from "@/components/modal/EditUser.vue";
import {EventBus} from "@/eventBus";

export default {
  name: "UserList",
  components: {EditUser, AddUser, ListControls, Header},
  mixins: [ListLogicMixin],
  data: () => {
    return {
      pageTitle: 'Users',
      pageFilter: '',
      pageTotal: '',
      total: 0,
      title: "Users",
      apiList: "/api/user/list",
      apiUrl: '/api/user/',
      apiMultyDelete: '/api/user/delete/',
      items: [],
      limit: localStorage.getItem('UserLimit') ?? "100",
      filterExact: [],
      filterValues: {
        'Id': null,
        'Email': null,
        'Role': null,
      },
      itemsSelectedCount: 0,
      allSelected: false,
      filterOptions: {
        'Role': {
          'options': [
            {
              "value": null,
              "label": "ANY"
            }
          ],
          'uri': '/api/user/list?group=Role',
          'labelField': 'Role',
          'valueField': 'Role'
        }
      }
    }
  },
  methods: {
    ChangeLimit(newLimit) {
      this.limit = newLimit;
      localStorage.setItem('UserLimit', newLimit);
      this.LoadData();
    },
    filterChanged() {
      this.filterSend()
    },
    loadOptions: async function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri && key !== 'UsedBy') {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key, this.filterOptions[key].options)
        }
      })
      this.filterPreparing();
      this.filterQuery();
      this.LoadData();
    },
    getOptions: function (labelField, valueField, query, key, currentOptions = []) {
      const options = currentOptions
      axios.post(query,[], this.authRespConf())
          .then(res => {
            if (res === undefined || res === null) {
              return []
            }
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                options.push({
                  value: res.data.data[dataIndex][valueField],
                  label: key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField],
                });
              }
            }
          });
      return options;
    },
    filterSend() {
      let currentQuery = this.$route.query;
      let newFilters = [];
      for (let FieldName in this.filterValues) {
        if (this.filterValues[FieldName] !== '') {
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (data[FieldName] !== null) {
            if (this.filterExact.includes(FieldName)) {
              newFilters.push({
                Condition: "=",
                Data: data,
              });
            } else {
              newFilters.push({
                Condition: "ilike",
                Data: data,
              });
            }
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(newFilters)}});
        this.filters = newFilters;
        this.LoadData()
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
    addUser: function () {
      this.$modal.show('addUser')
    },
    editItem(item) {
      this.currentItemId = parseInt(item.Id);
      this.$modal.show('editUser');
    },
    openDeleteItemConfirmation(item) {
      this.confirmModalTitle = 'Confirm delete User: ' + item.Email;
      this.currentItemId = parseInt(item.Id);
      this.$modal.show('confirmItemDelete');
    },
    selectAll: function () {
      this.selectedItemsList = [];
      this.itemsSelectedCount = 0
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    actionDelete() {
      this.confirmModalTitle = 'Confirm delete Users';
      this.confirmModalMsg =
          'Are you sure you want to delete ' +
          document.getElementsByClassName('selected').length +
          ' Users?';
      this.$modal.show('confirm');
    },
    closeEditModal() {
      this.currentItemId = null;
      this.LoadData()
    },
    modalsHide() {
      this.$modal.hide('addUser');
      this.$modal.hide('editUser');
      this.$modal.hide('confirmItemDelete');
      this.$modal.hide('confirm');
    },
  },
  watch: {
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
      if (this.itemsSelectedCount === 0) {
        this.allSelected = false
      }
    },
  },
  created: function () {
    this.loadOptions();
    EventBus.$on("EscapeKeyDown", this.modalsHide);
  },
  beforeDestroy() {
    EventBus.$off("EscapeKeyDown", this.modalsHide);
  },
}
</script>

<template>
  <div class="page">
    <Header
        :title=title
        :filter=pageFilter
        :total=pageTotal
    />
    <div class="container dashboard card">
      <div class="card-header">
        <span class="other-buttons">
          <button @click="downloadTable()" class="btn btn-primary">
            <i class="fa fa-download"></i>
          </button>
        </span>
        <span class="other-buttons"><button @click="addUser()" class="btn btn-primary">Add User</button></span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select IPs to delete">
        <button class="btn btn-default delete-btn small icon-only"
                @click="actionDelete()"
                :class="['btn btn-danger', { 'disabled': itemsSelectedCount === 0 }]">
                    Delete <span v-if="itemsSelectedCount <= 1">User</span><span v-else>Users</span>  <i
            class="fa fa-trash"></i>
                  </button>
        </span>
      </div>
      <div class="card-body">
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Id')">ID</span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 7rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('State')">Email</span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Address')">Role</span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th/>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <tr @keyup.enter="filterChanged">
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Id']" placeholder="ID"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="ID" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Email']" placeholder="Email"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Email" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>

            </th>
            <th>
              <b-form-select
                  :options="filterOptions.Role.options"
                  text-field="label"
                  value-field="value"
                  @change="filterChanged"
                  v-model="filterValues.Role"
                  placeholder="Select Role.."
                  inputId="role"
                  clearable/>
            </th>
            <th>
            <span class="cel-buttons">
              <span class="icon-search" @click="filterChanged()" title="Apply filters"><i
                  class="fa fa-solid fa-search"></i></span>
               <span class="icon-clear" @click="clearFilter()" title="Clear filters">
                <font-awesome-icon icon="recycle" class="icon alt"/>
               </span>
            </span>
            </th>
            <th/>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td>
              <span class="cel-text">{{ item.Id }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Email }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Role }}</span>
            </td>
            <td>
              <span class="cel-buttons">
                <button class="btn btn-as-link icon-only" @click="editItem(item)"><i class="fa fa-pencil"></i></button>
                <button class="btn btn-as-link icon-only  text-danger" @click="openDeleteItemConfirmation(item)"><i
                    class="fa fa-trash"></i></button>
              </span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items?.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="[
                {value: '10',text: '10'},
                {value: '50',text: '50'},
                {value: '100',text: '100'},
                {value: '500',text: '500'},
                {value: '1000',text: '1000'},
            ]"
        />
      </div>
    </div>
    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :title="confirmModalTitle"
        :url="apiUrl"
        :itemId="currentItemId"
    />
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>
    <AddUser :role-options="filterOptions.Role.options" @closed="LoadData"/>
    <EditUser :userId="currentItemId" :role-options="filterOptions.Role.options"
              @closed="closeEditModal"/>
  </div>
</template>

<style scoped>

</style>